import Vue from 'vue';
// composition api should be the first installed plugin
// if not some conflicts may happen, this is fixed on vue-3
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import Flickity from 'vue-flickity';
import 'flickity-fullscreen';
import 'flickity-fullscreen/fullscreen.css';
Vue.component('flickity', Flickity);

import VModal from 'vue-js-modal/dist/index.nocss.js';
import 'vue-js-modal/dist/styles.css';
Vue.use(VModal);
